import { request } from './http';

export function login(email, password) {
  return request('/auth/login', { method: 'POST', auth: false, body: { email, password } });
}

export function logout(refreshToken) {
  return request('/auth/logout', {
    method: 'POST',
    auth: false,
    body: { refresh_token: refreshToken },
  });
}

export function recoverPassword(email) {
  return request('/auth/password/recover', { method: 'POST', auth: false, body: { email } });
}

export function getMe() {
  return request('/auth/me');
}

export function getProfile() {
  return request('/profile');
}

export function updateProfile(body) {
  return request('/profile', { method: 'PATCH', body });
}

export function updateTheme(theme) {
  return request('/profile/theme', { method: 'PATCH', body: { theme } });
}

export function changePassword(body) {
  return request('/profile/password', { method: 'POST', body });
}

export function requestEmailChange(email) {
  return request('/profile/email', { method: 'POST', body: { email } });
}

export function getProfileMenu() {
  return request('/profile/menu');
}

export function listProfileSessions() {
  return request('/profile/sessions');
}

export function revokeProfileSession(id) {
  return request(`/profile/sessions/${id}/revoke`, { method: 'POST' });
}

export function revokeAllProfileSessions() {
  return request('/profile/sessions/revoke-all', { method: 'POST' });
}

export function getMySections() {
  return request('/access/sections');
}

export function getStartSection() {
  return request('/access/start');
}

export function visitSection(section) {
  return request('/access/visit', { method: 'POST', body: { section } });
}

function userQuery({ page, perPage, order }) {
  const query = { page, sort: 'full_name', order };
  // Общий параметр per_page принимает 20, 50 и 100. 30 — размер по умолчанию,
  // его не передают: явное значение сервер отвечает 422.
  if (perPage !== 30) query.per_page = perPage;
  return query;
}

function userFilters(filters) {
  const body = {};
  if (filters.firstName) body.first_name = filters.firstName;
  if (filters.lastName) body.last_name = filters.lastName;
  if (filters.phone) body.phone = filters.phone;
  if (filters.email) body.email = filters.email;
  if (filters.role) body.role = [filters.role];
  if (filters.deleted) body.deleted = true;
  return body;
}

export function listUsers({ page, perPage, order, filters }) {
  const query = userQuery({ page, perPage, order });
  const body = userFilters(filters);
  if (Object.keys(body).length) {
    return request('/users', { method: 'POST', query, body });
  }
  return request('/users', { query });
}

export function createUser(body) {
  return request('/users/create', { method: 'POST', body });
}

export function generatePassword() {
  return request('/users/generate-password', { method: 'POST' });
}

export function getUser(id) {
  return request(`/users/${id}`);
}

export function updateUser(id, body) {
  return request(`/users/${id}`, { method: 'PATCH', body });
}

export function listDivisions() {
  return request('/managers/divisions');
}

export function deleteUser(id) {
  return request(`/users/${id}`, { method: 'DELETE' });
}

export function restoreUser(id, comment) {
  return request(`/users/${id}/restore`, { method: 'POST', body: { comment } });
}

export function resendInvitation(id) {
  return request(`/users/${id}/resend-invitation`, { method: 'POST' });
}

export function resetUserPassword(id) {
  return request(`/users/${id}/reset-password`, { method: 'POST' });
}

export function getUserAudit(id, { page, perPage, category }) {
  const query = { page, sort: 'occurred_at', order: 'desc' };
  if (perPage && perPage !== 30) query.per_page = perPage;
  if (category) {
    return request(`/users/${id}/audit-log`, { method: 'POST', query, body: { category } });
  }
  return request(`/users/${id}/audit-log`, { query });
}
